import { segmentConditions } from 'constants/filters';

import { CONTENT_GRID_PERSONALIZATION_FILTER_OPTIONS } from './audienceFilterOptions';
import { isAudienceFilterRowComplete } from './personalizationFilterUtils';

const OPERATOR_OPTIONS = segmentConditions[0]?.options ?? [];

const findProperty = (type) =>
  CONTENT_GRID_PERSONALIZATION_FILTER_OPTIONS.find(
    (option) => option.value.type === type,
  );

const operatorPhrase = (operator) => {
  const match = OPERATOR_OPTIONS.find((option) => option.value === operator);
  return (match?.label ?? 'Is').toLowerCase();
};

const valueLabel = (property, raw) => {
  const normalized = String(raw ?? '').trim();
  const fromOptions = property?.config?.options?.find(
    (option) =>
      option.value === normalized ||
      String(option.value).toLowerCase() === normalized.toLowerCase(),
  );
  return fromOptions?.label ?? normalized;
};

/** One display segment per property/value (e.g. Device + Desktop, Device + Mobile). */
export const personalizationFilterClauses = (rows = []) =>
  rows.filter(isAudienceFilterRowComplete).flatMap((row) => {
    const property = findProperty(row.property.type);
    const propertyLabel = property?.label ?? row.property.type;
    const op = operatorPhrase(row.operator);

    if (row.operator === 'IS_EMPTY' || row.operator === 'NOT_EMPTY') {
      return [`{${propertyLabel}} ${op}`];
    }

    const values = row.value ?? [];
    return values.map(
      (value) => `{${propertyLabel}} ${op} {${valueLabel(property, value)}}`,
    );
  });

export const PERSONALIZATION_DEFAULT_HELP =
  'Select a filter and customize asset personalization; assets will be shown based on what you set as criteria.';

export const SETS_PANEL_INTRO =
  'Select a filter and customize asset personalization, assets will be shown based';

/** Incomplete set indicator (accordion header). */
export const SET_INCOMPLETE_COLLAPSED_TOOLTIP = 'Empty';
